import React from 'react';
import { createRoot } from 'react-dom/client';
import BlackAndWhite from '../components/BlackAndWhite';
const projectContainer = document.getElementById('black-and-white-page');

if (projectContainer) {
  const root = createRoot(projectContainer);
  root.render(
    // <React.StrictMode> // Optional, good for development
      <BlackAndWhite />
    // </React.StrictMode>
  );
} else {
  console.error("Root element for BlackAndWhite (#black-and-white-page) not found. Check your Rails view.");
}